import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import background from "../../asset/background/player-background.webp";
import { Level } from "../../service/LevelService";

/**
 * The level card as the participant's phone shows it: the same places and the same face as the player app's
 * LevelCard (apps/player/src/game/LevelCard.tsx + index.css), scaled to a phone frame. Change one, change both.
 */
export default function LevelPreview({ level, of, height = 640 }: { level: Level; of: number; height?: number }) {
  const [t] = useTranslation("global");
  const width = Math.round(height * 0.46);
  const vh = height / 100;
  const text = (top: number, size: number, extra: object = {}) => ({
    position: "absolute" as const,
    top: `${top}%`,
    left: 0,
    width: "100%",
    margin: 0,
    padding: "0 8px",
    boxSizing: "border-box" as const,
    textAlign: "center" as const,
    color: "#000",
    fontFamily: '"Roboto Condensed", Roboto, sans-serif',
    fontWeight: 700,
    lineHeight: 1,
    whiteSpace: "nowrap" as const,
    fontSize: size * vh,
    ...extra,
  });
  const name = level.name || t("levels.previewLevel", { number: level.number, of });
  return (
    <Box
      sx={{
        width,
        height,
        borderRadius: `${height * 0.06}px`,
        border: "6px solid #222",
        overflow: "hidden",
        position: "relative",
        backgroundColor: "#FFF5EE",
        backgroundImage: `url(${background})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        flex: "none",
      }}
    >
      <p style={text(20.5, 2.4)}>{level.heading || t("levels.previewHeading")}</p>
      <p style={text(23.6, 4)}>{name}</p>
      {level.name && <p style={text(28, 2, { color: "#444" })}>{t("levels.previewLevel", { number: level.number, of })}</p>}
      {level.imageUrl && <img src={level.imageUrl} alt="" style={{ position: "absolute", top: "29.3%", left: 0, width: "100%", height: "38.5%", objectFit: "fill" }} />}
      <p style={text(69.1, 4.4)}>POINT</p>
      <p style={text(76, 7.5, { fontFamily: "Roboto, sans-serif", fontWeight: 800 })}>{(level.minScore + 1234).toLocaleString("da-DK")}</p>
      <p style={text(85, 2.2, { color: "#666", fontFamily: "Roboto, sans-serif", fontWeight: 400 })}>{t("levels.previewTotal", { score: (level.minScore + 1234).toLocaleString("da-DK") })}</p>
    </Box>
  );
}
